import React, { useEffect, useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import { CalendarIcon, FilterIcon, GridIcon, ListIcon, SearchIcon, TagIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import Button from '../components/ui/Button';
import Badge from '../components/ui/Badge';
interface Event {
  id: string;
  title: string;
  date: string;
  startTime: string;
  endTime: string;
  location: string;
  category: 'academic' | 'sports' | 'cultural' | 'alumni' | 'pta' | 'general';
  description: string;
  image?: string;
  featured?: boolean;
}
const Events = () => {
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [filterOpen, setFilterOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [filteredEvents, setFilteredEvents] = useState<Event[]>([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  // Sample events data
  const events: Event[] = [{
    id: '1',
    title: 'Inter-House Sports Competition',
    date: '2023-11-10',
    startTime: '09:00',
    endTime: '16:00',
    location: 'School Sports Ground',
    category: 'sports',
    description: 'Annual inter-house sports competition featuring track and field events, team sports, and individual competitions.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9KTZ7HUP1wb7ieQ2CeaS6b/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg',
    featured: true
  }, {
    id: '2',
    title: 'PTA General Meeting',
    date: '2023-10-28',
    startTime: '10:00',
    endTime: '12:00',
    location: 'School Hall',
    category: 'pta',
    description: 'Quarterly meeting of the Parent-Teacher Association to discuss school development and student welfare.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg'
  }, {
    id: '3',
    title: 'Annual Alumni Reunion',
    date: '2023-12-15',
    startTime: '12:00',
    endTime: '18:00',
    location: 'School Grounds',
    category: 'alumni',
    description: 'Yearly gathering of alumni to reconnect, network, and give back to the school community.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nn93xnwTcDMxPXw6huLouK/WhatsApp_Image_2025-08-14_at_15.45.40_%281%29.jpg'
  }, {
    id: '4',
    title: 'Cultural Day Celebration',
    date: '2023-12-05',
    startTime: '10:00',
    endTime: '15:00',
    location: 'School Hall',
    category: 'cultural',
    description: "A celebration of Nigeria's diverse cultures featuring traditional dances, attire, and cuisine.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    featured: true
  }, {
    id: '5',
    title: 'First Term Examinations',
    date: '2023-11-20',
    startTime: '08:00',
    endTime: '14:00',
    location: 'Classrooms',
    category: 'academic',
    description: 'First term examinations for all classes. Students are reminded to prepare adequately.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg'
  }, {
    id: '6',
    title: 'Science and Technology Fair',
    date: '2024-02-15',
    startTime: '09:00',
    endTime: '15:00',
    location: 'School Hall',
    category: 'academic',
    description: 'Exhibition of student projects in science, technology, engineering, and mathematics.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg'
  }, {
    id: '7',
    title: 'Christmas Carol Service',
    date: '2023-12-12',
    startTime: '16:00',
    endTime: '18:00',
    location: 'School Chapel',
    category: 'cultural',
    description: 'Annual carol service featuring performances by the school choir and drama group.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg'
  }, {
    id: '8',
    title: 'Career Day',
    date: '2024-03-05',
    startTime: '10:00',
    endTime: '14:00',
    location: 'School Hall',
    category: 'academic',
    description: 'Professionals from various fields visit to share insights about their careers with students.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b9sNC2W3z8KYjzQztqrzUk/WhatsApp_Image_2025-10-24_at_10.01.23_%281%29.jpg'
  }, {
    id: '9',
    title: "Founders' Day",
    date: '2024-02-15',
    startTime: '10:00',
    endTime: '14:00',
    location: 'School Grounds',
    category: 'general',
    description: "Annual celebration of the school's founding featuring special assemblies, alumni visits, and various activities.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg'
  }, {
    id: '10',
    title: 'End of Term Ceremony',
    date: '2023-12-08',
    startTime: '10:00',
    endTime: '12:00',
    location: 'School Hall',
    category: 'general',
    description: 'Ceremony to mark the end of the first term with awards presentations and cultural performances.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg'
  }];
  // Filter events based on search query and selected category
  useEffect(() => {
    let results = [...events];
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      results = results.filter(event => event.title.toLowerCase().includes(query) || event.description.toLowerCase().includes(query) || event.location.toLowerCase().includes(query));
    }
    if (selectedCategory) {
      results = results.filter(event => event.category === selectedCategory);
    }
    // Sort by date
    results.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    setFilteredEvents(results);
  }, [searchQuery, selectedCategory]);
  // Format date for display
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  // Generate calendar days for the current month view
  const generateCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    // First day of the month
    const firstDay = new Date(year, month, 1);
    // Last day of the month
    const lastDay = new Date(year, month + 1, 0);
    // Day of week for the first day (0 = Sunday, 6 = Saturday)
    const firstDayOfWeek = firstDay.getDay();
    // Total days in the month
    const daysInMonth = lastDay.getDate();
    // Generate array of calendar days
    const days = [];
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDayOfWeek; i++) {
      days.push({
        day: null,
        date: null
      });
    }
    // Add cells for each day of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const dateString = date.toISOString().split('T')[0];
      // Find events for this day
      const dayEvents = events.filter(event => event.date === dateString);
      days.push({
        day,
        date: dateString,
        events: dayEvents
      });
    }
    return days;
  };
  // Navigate to previous month
  const goToPreviousMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };
  // Navigate to next month
  const goToNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };
  // Get category badge variant
  const getCategoryBadge = (category: string) => {
    switch (category) {
      case 'academic':
        return {
          variant: 'primary',
          label: 'Academic'
        };
      case 'sports':
        return {
          variant: 'success',
          label: 'Sports'
        };
      case 'cultural':
        return {
          variant: 'warning',
          label: 'Cultural'
        };
      case 'alumni':
        return {
          variant: 'info',
          label: 'Alumni'
        };
      case 'pta':
        return {
          variant: 'secondary',
          label: 'PTA'
        };
      default:
        return {
          variant: 'default',
          label: 'General'
        };
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-3501">
      <PageHeader title="Events Calendar" description="Stay updated with all the events, activities, and important dates at Isonyin Grammar School." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Events',
      path: '/events'
    }]} data-id="element-3502" />
      <div className="container mx-auto px-4 py-12" data-id="element-3503">
        {/* Featured Events */}
        <section className="mb-16" data-id="element-3504">
          <h2 className="text-3xl font-bold text-blue-900 mb-6" data-id="element-3505">
            Featured Events
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-3506">
            {events.filter(event => event.featured).map(event => <div key={event.id} className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col md:flex-row" data-id="element-3507">
                  <div className="md:w-2/5 h-64 md:h-auto" data-id="element-3508">
                    <img src={event.image || 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80'} alt={event.title} className="w-full h-full object-cover" data-id="element-3509" />
                  </div>
                  <div className="md:w-3/5 p-6 flex flex-col justify-between" data-id="element-3510">
                    <div data-id="element-3511">
                      <div className="flex items-center mb-3" data-id="element-3512">
                        <Badge variant={getCategoryBadge(event.category).variant as any} data-id="element-3513">
                          {getCategoryBadge(event.category).label}
                        </Badge>
                        <span className="ml-2 text-gray-500 text-sm" data-id="element-3514">
                          {formatDate(event.date)}
                        </span>
                      </div>
                      <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-3515">
                        {event.title}
                      </h3>
                      <div className="flex items-center text-gray-600 mb-3 text-sm" data-id="element-3516">
                        <CalendarIcon className="h-4 w-4 mr-2" data-id="element-3517" />
                        <span data-id="element-3518">
                          {event.startTime} - {event.endTime}
                        </span>
                        <span className="mx-2" data-id="element-3519">•</span>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3520">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-3521" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-3522" />
                        </svg>
                        <span data-id="element-3523">{event.location}</span>
                      </div>
                      <p className="text-gray-700 mb-4" data-id="element-3524">{event.description}</p>
                    </div>
                    <Button href={`/events/${event.id}`} variant="primary" size="sm" data-id="element-3525">
                      View Details
                    </Button>
                  </div>
                </div>)}
          </div>
        </section>

        {/* Calendar View */}
        <section className="mb-16" data-id="element-3526">
          <div className="flex justify-between items-center mb-6" data-id="element-3527">
            <h2 className="text-3xl font-bold text-blue-900" data-id="element-3528">
              Events Calendar
            </h2>
            <div className="flex items-center space-x-2" data-id="element-3529">
              <button onClick={goToPreviousMonth} className="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500" aria-label="Previous month" data-id="element-3530">
                <ChevronLeftIcon className="h-5 w-5 text-blue-900" data-id="element-3531" />
              </button>
              <h3 className="text-lg font-medium text-blue-900 min-w-[150px] text-center" data-id="element-3532">
                {months[currentMonth.getMonth()]} {currentMonth.getFullYear()}
              </h3>
              <button onClick={goToNextMonth} className="p-2 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500" aria-label="Next month" data-id="element-3533">
                <ChevronRightIcon className="h-5 w-5 text-blue-900" data-id="element-3534" />
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-3535">
            <div className="grid grid-cols-7 bg-blue-900 text-white text-center py-2" data-id="element-3536">
              <div data-id="element-3537">Sun</div>
              <div data-id="element-3538">Mon</div>
              <div data-id="element-3539">Tue</div>
              <div data-id="element-3540">Wed</div>
              <div data-id="element-3541">Thu</div>
              <div data-id="element-3542">Fri</div>
              <div data-id="element-3543">Sat</div>
            </div>
            <div className="grid grid-cols-7 border-t border-gray-200" data-id="element-3544">
              {generateCalendarDays().map((day, index) => <div key={index} className={`min-h-[120px] p-2 border-b border-r border-gray-200 ${!day.day ? 'bg-gray-50' : ''} ${day.events?.length ? 'hover:bg-blue-50' : ''}`} data-id="element-3545">
                  {day.day && <>
                      <div className="text-right mb-1" data-id="element-3546">
                        <span className="text-sm font-medium text-gray-700" data-id="element-3547">
                          {day.day}
                        </span>
                      </div>
                      <div className="space-y-1" data-id="element-3548">
                        {day.events?.map(event => <a key={event.id} href={`/events/${event.id}`} className="block p-1 text-xs bg-blue-100 text-blue-800 rounded truncate hover:bg-blue-200" data-id="element-3549">
                            {event.startTime} - {event.title}
                          </a>)}
                      </div>
                    </>}
                </div>)}
            </div>
          </div>
        </section>

        {/* Events Listing */}
        <section data-id="element-3550">
          <div className="flex flex-wrap justify-between items-center mb-6" data-id="element-3551">
            <h2 className="text-3xl font-bold text-blue-900 mb-4 md:mb-0" data-id="element-3552">
              Upcoming Events
            </h2>
            <div className="flex flex-wrap items-center space-x-2" data-id="element-3553">
              <div className="relative" data-id="element-3554">
                <input type="text" placeholder="Search events..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-3555" />
                <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-3556" />
              </div>
              <button onClick={() => setFilterOpen(!filterOpen)} className="flex items-center px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-3557">
                <FilterIcon className="h-4 w-4 mr-2" data-id="element-3558" />
                Filter
              </button>
              <div className="hidden md:flex bg-gray-100 rounded-md" data-id="element-3559">
                <button onClick={() => setViewMode('grid')} className={`p-2 rounded-l-md ${viewMode === 'grid' ? 'bg-blue-900 text-white' : 'text-gray-700 hover:bg-gray-200'}`} aria-label="Grid view" data-id="element-3560">
                  <GridIcon className="h-5 w-5" data-id="element-3561" />
                </button>
                <button onClick={() => setViewMode('list')} className={`p-2 rounded-r-md ${viewMode === 'list' ? 'bg-blue-900 text-white' : 'text-gray-700 hover:bg-gray-200'}`} aria-label="List view" data-id="element-3562">
                  <ListIcon className="h-5 w-5" data-id="element-3563" />
                </button>
              </div>
            </div>
          </div>

          {/* Filter options */}
          {filterOpen && <div className="bg-gray-50 p-4 rounded-lg mb-6 animate-fadeIn" data-id="element-3564">
              <h3 className="font-medium text-gray-900 mb-3" data-id="element-3565">
                Filter by Category
              </h3>
              <div className="flex flex-wrap gap-2" data-id="element-3566">
                <button onClick={() => setSelectedCategory(null)} className={`px-3 py-1 rounded-full text-sm ${!selectedCategory ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3567">
                  All Categories
                </button>
                <button onClick={() => setSelectedCategory('academic')} className={`px-3 py-1 rounded-full text-sm ${selectedCategory === 'academic' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3568">
                  Academic
                </button>
                <button onClick={() => setSelectedCategory('sports')} className={`px-3 py-1 rounded-full text-sm ${selectedCategory === 'sports' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3569">
                  Sports
                </button>
                <button onClick={() => setSelectedCategory('cultural')} className={`px-3 py-1 rounded-full text-sm ${selectedCategory === 'cultural' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3570">
                  Cultural
                </button>
                <button onClick={() => setSelectedCategory('alumni')} className={`px-3 py-1 rounded-full text-sm ${selectedCategory === 'alumni' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3571">
                  Alumni
                </button>
                <button onClick={() => setSelectedCategory('pta')} className={`px-3 py-1 rounded-full text-sm ${selectedCategory === 'pta' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3572">
                  PTA
                </button>
                <button onClick={() => setSelectedCategory('general')} className={`px-3 py-1 rounded-full text-sm ${selectedCategory === 'general' ? 'bg-blue-900 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-3573">
                  General
                </button>
              </div>
            </div>}

          {/* Grid view */}
          {viewMode === 'grid' && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-3574">
              {filteredEvents.map(event => <div key={event.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-3575">
                  <div className="h-48 overflow-hidden" data-id="element-3576">
                    <img src={event.image || 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80'} alt={event.title} className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500" data-id="element-3577" />
                  </div>
                  <div className="p-6" data-id="element-3578">
                    <div className="flex items-center mb-3" data-id="element-3579">
                      <Badge variant={getCategoryBadge(event.category).variant as any} data-id="element-3580">
                        {getCategoryBadge(event.category).label}
                      </Badge>
                    </div>
                    <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-3581">
                      {event.title}
                    </h3>
                    <div className="flex items-center text-gray-600 mb-3 text-sm" data-id="element-3582">
                      <CalendarIcon className="h-4 w-4 mr-2" data-id="element-3583" />
                      <span data-id="element-3584">{formatDate(event.date)}</span>
                    </div>
                    <div className="flex items-center text-gray-600 mb-3 text-sm" data-id="element-3585">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3586">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-3587" />
                      </svg>
                      <span data-id="element-3588">
                        {event.startTime} - {event.endTime}
                      </span>
                    </div>
                    <div className="flex items-center text-gray-600 mb-4 text-sm" data-id="element-3589">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3590">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-3591" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-3592" />
                      </svg>
                      <span data-id="element-3593">{event.location}</span>
                    </div>
                    <p className="text-gray-700 mb-4 line-clamp-3" data-id="element-3594">
                      {event.description}
                    </p>
                    <Button href={`/events/${event.id}`} variant="outline" size="sm" fullWidth data-id="element-3595">
                      View Details
                    </Button>
                  </div>
                </div>)}
            </div>}

          {/* List view */}
          {viewMode === 'list' && <div className="space-y-4" data-id="element-3596">
              {filteredEvents.map(event => <div key={event.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-3597">
                  <div className="flex flex-col md:flex-row" data-id="element-3598">
                    <div className="md:w-1/4 lg:w-1/5" data-id="element-3599">
                      <img src={event.image || 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80'} alt={event.title} className="w-full h-48 md:h-full object-cover" data-id="element-3600" />
                    </div>
                    <div className="p-6 md:w-3/4 lg:w-4/5" data-id="element-3601">
                      <div className="flex flex-wrap items-center justify-between mb-3" data-id="element-3602">
                        <Badge variant={getCategoryBadge(event.category).variant as any} data-id="element-3603">
                          {getCategoryBadge(event.category).label}
                        </Badge>
                        <span className="text-gray-500 text-sm" data-id="element-3604">
                          {formatDate(event.date)}
                        </span>
                      </div>
                      <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-3605">
                        {event.title}
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3" data-id="element-3606">
                        <div className="flex items-center text-gray-600 text-sm" data-id="element-3607">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3608">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-3609" />
                          </svg>
                          <span data-id="element-3610">
                            {event.startTime} - {event.endTime}
                          </span>
                        </div>
                        <div className="flex items-center text-gray-600 text-sm" data-id="element-3611">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-3612">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" data-id="element-3613" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-3614" />
                          </svg>
                          <span data-id="element-3615">{event.location}</span>
                        </div>
                      </div>
                      <p className="text-gray-700 mb-4" data-id="element-3616">{event.description}</p>
                      <Button href={`/events/${event.id}`} variant="outline" size="sm" data-id="element-3617">
                        View Details
                      </Button>
                    </div>
                  </div>
                </div>)}
            </div>}

          {filteredEvents.length === 0 && <div className="text-center py-12 bg-gray-50 rounded-lg" data-id="element-3618">
              <CalendarIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" data-id="element-3619" />
              <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-3620">
                No events found
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-3621">
                {searchQuery || selectedCategory ? 'Try adjusting your search or filters to find events.' : 'There are no upcoming events scheduled at this time.'}
              </p>
              {(searchQuery || selectedCategory) && <Button variant="outline" onClick={() => {
            setSearchQuery('');
            setSelectedCategory(null);
          }} data-id="element-3622">
                  Clear Filters
                </Button>}
            </div>}
        </section>

        {/* Subscribe to Events */}
        <section className="mt-16 bg-blue-900 text-white p-8 rounded-lg text-center" data-id="element-3623">
          <h2 className="text-2xl font-bold mb-4" data-id="element-3624">
            Stay Updated with School Events
          </h2>
          <p className="mb-6 max-w-2xl mx-auto" data-id="element-3625">
            Subscribe to our events calendar to receive notifications about
            upcoming events, schedule changes, and important dates.
          </p>
          <div className="max-w-md mx-auto flex flex-col sm:flex-row gap-4" data-id="element-3626">
            <input type="email" placeholder="Your email address" className="px-4 py-2 rounded-md flex-grow text-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-500" data-id="element-3627" />
            <Button variant="primary" data-id="element-3628">Subscribe</Button>
          </div>
          <p className="text-sm mt-4 text-blue-200" data-id="element-3629">
            You can unsubscribe at any time. View our{' '}
            <a href="/privacy-policy" className="underline" data-id="element-3630">
              Privacy Policy
            </a>
            .
          </p>
        </section>
      </div>
    </div>;
};
export default Events;